// extracted by mini-css-extract-plugin
module.exports = {"lecture__date":"lecture-module__lecture__date___ah9q-","lecture__title":"lecture-module__lecture__title___37Zi0","content":"lecture-module__content___wok8T"};